import {
	CategoriesSvg,
	CatDoseMapSvg,
	CSVSvg,
	DashboardSvg,
	EmailSvg,
	GroceriesSidebarIcon,
	QualityCheckSvg,
	RejectSvg,
	RoleSvg,
	SubCategoriesSvg,
	UsersSvg,
	WarningSvg
} from 'utils/svgs';

const validateNoOnlySpaces = (_: any, value: any) => {
	if (value && value.trim() === '') {
		return Promise.reject('Please enter valid value');
	}
	return Promise.resolve();
};

export const GROCERY_PACK_TYPE_OPTIONS = [
	{ value: 'Bottle', label: 'Bottle' },
	{ value: 'Packet', label: 'Packet' },
	{ value: 'Box', label: 'Box' },
	{ value: 'Unit', label: 'Unit' },
	{ value: 'Tin', label: 'Tin' },
	{ value: 'Cans', label: 'Cans' },
	{ value: 'Tetra_Packs', label: 'Tetra Packs' },
	{ value: 'Vials', label: 'Vials' },
	{ value: 'Tubes', label: 'Tubes' },
	{ value: 'Jar', label: 'Jar' },
	{ value: 'Sachet', label: 'Sachet' },
	{ value: 'Wrapper', label: 'Wrapper' },
	{ value: 'Blister_Pack', label: 'Blister Pack' },
	{ value: 'Tray', label: 'Tray' },
	{ value: 'Strip', label: 'Strip' },
	{ value: 'Carton', label: 'Carton' },
	{ value: 'Family_Pack', label: 'Family Pack' },
	{ value: 'Combo_Pack', label: 'Combo Pack' },
	{ value: 'Twin_Pack', label: 'Twin Pack' },
	{ value: 'Value_Pack', label: 'Value Pack' },
	{ value: 'Refill_Pack', label: 'Refill Pack' },
	{ value: 'Single_Serve', label: 'Single Serve' },
];

export const ITEM_SIZE_OPTIONS = [
	{ value: 'XS', label: 'XS' },
	{ value: 'S', label: 'S' },
	{ value: 'M', label: 'M' },
	{ value: 'L', label: 'L' },
	{ value: 'XL', label: 'XL' },
	{ value: 'XXL', label: '2XL' },
	{ value: 'XXXL', label: '3XL' },
	{ value: 'XXXXL', label: '4XL' },
];

const ITEM_SIZE_LABELS: Record<string, string> = Object.fromEntries(
	ITEM_SIZE_OPTIONS.map(({ value, label }) => [value, label]),
);

export const formatItemSizeLabel = (itemSize?: string | null): string | undefined => {
	if (!itemSize) return undefined;
	return ITEM_SIZE_LABELS[itemSize] ?? itemSize;
};

export const FORMDATA = {
	loginFields: [
		{
			title: 'Enter your email address',
			id: 'email',
			type: 'text',
			name: 'email',
			// svg: <UsersSvg />,
			placeHolder: 'Email address',
			required: true,
			rules: [
				{
					required: true,
					message: 'Please enter your email address',
					validateTrigger: 'onChange',
				},
				{
					type: 'email',
					message: 'Please enter valid email',
					validateTrigger: 'onChange',
				},
			],
		},
		{
			title: 'Enter your password',
			id: 'password',
			type: 'password',
			name: 'password',
			// svg: <PasswordSvg />,
			placeHolder: 'Password',
			required: true,
			rules: [
				{
					required: true,
					message: 'Please enter your password',
					validateTrigger: 'onChange',
				},
				{
					pattern:
						/^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&])[A-Za-z\d@$!%*?&]{8,}$/,
					message:
						'Password must contain at least 1 uppercase, 1 lowercase, 1 number, and 1 special character',
					validateTrigger: 'onChange',
				},
			],
		},
	],
	resetPassword: [
		{
			title: 'Enter new password',
			id: 'password',
			type: 'password',
			name: 'password',
			// svg: <PasswordSvg />,
			placeHolder: '',
			required: true,
			rules: [
				{
					required: true,
					message: 'Please enter your password',
					validateTrigger: 'onChange',
				},
				{
					pattern:
						/^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&])[A-Za-z\d@$!%*?&]{8,}$/,
					message:
						'Password must contain at least 1 uppercase, 1 lowercase, 1 number, and 1 special character',
					validateTrigger: 'onChange',
				},
			],
		},
		{
			title: 'Confirm new password',
			id: 'confirmPassword',
			type: 'password',
			name: 'confirmPassword',
			// svg: <PasswordSvg />,
			placeHolder: '',
			required: true,
			rules: [
				{
					required: true,
					message: 'Please enter your password again',
					validationTrigger: 'onChange',
				},
				({ getFieldValue }: any) => ({
					validator(_: any, value: any) {
						if (!value || getFieldValue('password') === value) {
							return Promise.resolve();
						}
						return Promise.reject(
							new Error('Passwords do not match')
						);
					},
					validateTrigger: 'onChange',
				}),
			],
		},
	],
	forgotPassword: [
		{
			title: 'Email address',
			id: 'email',
			type: 'text',
			name: 'email',
			svg: <EmailSvg />,
			placeHolder: '',
			required: true,
			rules: [
				{
					required: true,
					message: 'Please enter your email address',
					validateTrigger: 'onChange',
				},
				{
					type: 'email',
					message: 'Please enter valid email',
					validateTrigger: 'onChange',
				},
			],
		},
	],
	settingsMenuItems: [
		{
			key: 'users',
			icon: <UsersSvg />,
			label: 'Users',
		},
		{
			key: 'roles',
			icon: <RoleSvg />,
			label: 'Roles',
		},
		{
			key: 'staff',
			icon: <UsersSvg />,
			label: 'Staff',
		},
		{
			key: 'import-data',
			icon: <CSVSvg />,
			label: 'Import Data',
		},
	],
	configurationMenuItems: [
		{
			key: 'company',
			label: 'Company',
		},
		{
			key: 'branch-code',
			label: 'Branch code',
		},
		{
			key: 'category-code',
			label: 'Category code',
		},
		{
			key: 'job-title',
			label: 'Job Title',
		},
		{
			key: 'pay-point',
			label: 'Pay Point',
		},
		{
			key: 'department',
			label: 'Department ',
		},
		{
			key: 'cost-center',
			label: 'Cost Center ',
		},
		{
			key: 'job-grade',
			label: 'Job Grade',
		},
		// {
		// 	key: 'earning',
		// 	label: 'Earning',
		// },
		// {
		// 	key: 'deduction',
		// 	label: 'Deduction',
		// },
		{
			key: 'leave-management',
			label: 'Leave Management',
		},
		{
			key: 'holidays',
			label: 'Holidays',
		},
	],
	approvalMenuItems: [
		{
			key: 'employee',
			label: 'Employee',
		},
		{
			key: 'time-sheet',
			label: 'Time Sheet',
		},
		{
			key: 'payroll',
			label: 'Payroll',
		},
	],
	medicinePanelMenuItems: [
		{
			key: 'dashboard',
			label: 'Dashboard',
			icon: <DashboardSvg />,
		},
		{
			key: 'quality-check',
			label: 'Quality Check',
			icon: <QualityCheckSvg />,
		},
		{
			key: 'medicines',
			label: 'Medicines',
			icon: <GroceriesSidebarIcon />,
		},
		{
			key: 'combos',
			label: 'Combos',
			icon: <GroceriesSidebarIcon />,
		},
		{
			key: 'draft-medicines-request',
			label: (
				<span className="sidebar-stacked-label">
					<span>Draft Medicines</span>
					<span>Request</span>
				</span>
			),
			icon: <GroceriesSidebarIcon />,
		},
		{
			key: 'rejected',
			label: 'Rejected',
			icon: <RejectSvg />,
		},
		{
			key: 'categories',
			label: 'Categories',
			icon: <CategoriesSvg />,
		},
		{
			key: 'sub-categories',
			label: 'Sub Categories',
			icon: <SubCategoriesSvg />,
		},
		{
			key: 'warning-tags',
			label: 'Warning Tags',
			icon: <WarningSvg />,
		},
		{
			key: 'dose-form',
			label: 'Dose Form',
			icon: <WarningSvg />,
		},
		{
			key: 'category-dose-form-mapping',
			label: 'CatDoseMap',
			icon: <CatDoseMapSvg />,
		},
	],
	/** Grocery panel sidebar */
	groceryPanelMenuItems: [
		{
			key: 'dashboard',
			label: 'Dashboard',
			icon: <DashboardSvg />,
		},
		{
			key: 'grocery-quality-check',
			label: 'Grocery QC',
			icon: <QualityCheckSvg />,
		},
		{
			key: 'groceries',
			label: 'Groceries',
			icon: <GroceriesSidebarIcon />,
		},
		{
			key: 'grocery-rejected',
			label: 'Grocery Rejected',
			icon: <RejectSvg />,
		},
		{
			key: 'grocery-categories',
			label: 'Categories',
			icon: <CategoriesSvg />,
		},
		{
			key: 'grocery-sub-categories',
			label: 'Sub Categories',
			icon: <SubCategoriesSvg />,
		},
	],
	addUserFields: [
		{
			title: 'Full Name',
			id: 'fullName',
			type: 'text',
			name: 'fullName',
			placeHolder: 'Enter your name',
			required: true,
			rules: [
				{
					required: true,
					message: 'Please enter your full name',
					validateTrigger: 'onChange',
				},
				{
					max: 30,
					message: 'Full name length must be less than 30 characters',
					validateTrigger: 'onChange',
				},
			],
		},
		{
			title: 'Select Role',
			id: 'roleName',
			type: 'text',
			name: 'roleName',
			defaultValue: '',
			placeholder: 'Enter role name',
			placeHolder: '',
			required: true,
			rules: [
				{
					required: true,
					message: 'Please select role',
					validateTrigger: 'onChange',
				},
			],
		},
		{
			title: 'Email Address',
			id: 'email',
			type: 'text',
			name: 'email',
			placeHolder: 'Enter your email address',
			required: true,
			rules: [
				{
					required: true,
					message: 'Please enter email address',
					validateTrigger: 'onChange',
				},
				{
					type: 'email',
					message: 'Please enter valid email address',
					validateTrigger: 'onChange',
				},
			],
		},
		// {
		// 	title: 'Phone Number',
		// 	id: 'phone',
		// 	type: 'text',
		// 	name: 'phone',
		// 	placeHolder: '',
		// 	required: true,
		// 	rules: [
		// 		{
		// 			validator: phoneNumberValidator,
		// 			validateTrigger: 'onChange',
		// 		},
		// 	],
		// },
	],
	addMedicineFields: [
		{
			title: 'Medicine Name',
			id: 'medicineName',
			type: 'text',
			name: 'medicineName',
			placeHolder: 'Enter Medicine Name',
			required: true,
			rules: [
				{
					required: true,
					message: 'Please enter Medicine Name',
					validateTrigger: 'onChange',
				},
				{
					max: 100,
					message:
						'Medicine name length must be less than 100 characters',
					validateTrigger: 'onChange',
				},
			],
		},
		{
			title: 'Generic Name',
			id: 'genericName',
			type: 'text',
			name: 'genericName',
			placeHolder: 'Enter Generic Name',
			required: false,
			rules: [
				{
					max: 100,
					message:
						'Generic name length must be less than 100 characters',
					validateTrigger: 'onChange',
				},
			],
		},
		{
			title: 'Manufacturer',
			id: 'manufacturer',
			type: 'text',
			name: 'manufacturer',
			placeHolder: 'Enter Manufacturer',
			required: true,
			rules: [
				{
					required: true,
					message: 'Please enter Manufacturer',
					validateTrigger: 'onChange',
				},
				{
					max: 99,
					message:
						'Manufacturer length must be less than 100 characters',
					validateTrigger: 'onChange',
				},
			],
		},
		{
			title: 'Marketed By',
			id: 'marketedBy',
			type: 'text',
			name: 'marketedBy',
			placeHolder: 'Enter Marketed By',
			required: false,
			rules: [
				{
					max: 100,
					message:
						'Marketed By length must be less than 100 characters',
					validateTrigger: 'onChange',
				},
			],
		},
		{
			title: 'Brand',
			id: 'brandName',
			type: 'text',
			name: 'brandName',
			placeHolder: 'Enter Brand',
			required: true,
			rules: [
				{
					required: true,
					message: 'Please enter Brand',
					validateTrigger: 'onChange',
				},
				{
					max: 99,
					message:
						'Brand length must be less than 100 characters',
					validateTrigger: 'onChange',
				},
			],
		},
		{
			title: 'Hsn Code',
			id: 'hsnCode',
			type: 'text',
			name: 'hsnCode',
			placeHolder: 'Enter hsnCode',
			required: false,
			rules: [
				{
					max: 100,
					message:
						'Hsn Code length must be less than 100 characters',
					validateTrigger: 'onChange',
				},
			],
		},
		{
			title: 'Product Code',
			id: 'productCode',
			type: 'text',
			name: 'productCode',
			placeHolder: 'Enter Product Code',
			required: false,
			rules: [],
		},
		{
			title: 'Description',
			id: 'shortDescription',
			type: 'text',
			name: 'shortDescription',
			placeHolder: 'Enter description',
			required: true,
			rules: [
				{
					required: true,
					message: 'Please enter Description',
					validateTrigger: 'onChange',
				},
				{
					max: 300,
					message:
						'Description length must be less than 300 characters',
					validateTrigger: 'onChange',
				},
			],
		},
		{
			title: 'Pack Size',
			id: 'packSize',
			type: 'dropdown',
			name: 'packSize',
			defaultValue: '',
			placeHolder: 'Enter Pack Size',
			required: true,
			rules: [
				{
					required: true,
					message: 'Please select Pack Size',
					validateTrigger: 'onChange',
				},
			],
			roleOptions: [
				{ value: 'BOTTLE', label: 'Bottle' },
				{ value: 'STRIP', label: 'Strip' },
				{ value: 'JAR', label: 'Jar' },
				{ value: 'TUBE', label: 'Tube' },
				{ value: 'PACKET', label: 'Packet' },
				{ value: 'BOX', label: 'Box' },
				{ value: 'COMBO_PACK', label: 'Combo Pack' },
				{ value: 'SACHET', label: 'Sachet' },
				{ value: 'VIAL', label: 'Vial' },
				{ value: 'KIT', label: 'Kit' },
				{ value: 'BAG', label: 'Bag' },
				{ value: 'TIN', label: 'Tin' },
			]
		},
		{
			title: 'Item Size',
			id: 'itemSize',
			type: 'dropdown',
			name: 'itemSize',
			placeHolder: 'Select item size',
			required: false,
			roleOptions: ITEM_SIZE_OPTIONS,
		},
		{
			title: 'Unit of Measure',
			id: 'unitOfMeasure',
			type: 'dropdown',
			name: 'unitOfMeasure',
			defaultValue: '',
			placeHolder: 'Enter unit of measure',
			required: true,
			rules: [
				{
					required: true,
					message: 'Please select unit of measure',
					validateTrigger: 'onChange',
				},
			],
			roleOptions: [
				{ value: 'GM', label: 'gm' },
				{ value: 'ML', label: 'ml' },
				{ value: 'KIT', label: 'kit' },
				{ value: 'KG', label: 'kg' },
				{ value: 'PIECE', label: 'piece' },
				{ value: 'TABLET', label: 'tablet' },
				{ value: 'CAPSULE', label: 'capsule' },
				{ value: 'LTR', label: 'ltr' },
				{ value: 'MG', label: 'mg' },
				{ value: 'SYRUP', label: 'syrup' },
				{ value: 'UNIT', label: 'unit' },
			],
		},
		{
			title: 'Liver Warning',
			id: 'liver',
			type: 'warning',
			name1: 'liver',
			name2: 'liverTagId',
			placeHolder: 'Select Liver Warning',
			required: false,
			rules: [
			],
		},
		{
			title: 'Alcohol Warning',
			id: 'alcohol',
			type: 'warning',
			name1: 'alcohol',
			name2: 'alcoholTagId',
			placeHolder: 'Select Alcohol Warning',
			required: false,
			rules: [
			],
		}, 
		{
			title: 'Driving Warning',
			id: 'driving',
			type: 'warning',
			name1: 'driving',
			name2: 'drivingTagId',
			placeHolder: 'Select Driving Warning',
			required: false,
			rules: [
			],
		},
		{
			title: 'Kidney Warning',
			id: 'kidney',
			type: 'warning',
			name1: 'kidney',
			name2: 'kidneyTagId',
			placeHolder: 'Select Kidney Warning',
			required: false,
			rules: [
			],
		},
		{
			title: 'Lactation Warning',
			id: 'lactation',
			type: 'warning',
			name1: 'lactation',
			name2: 'lactationTagId',
			placeHolder: 'Select Lactation Warning',
			required: false,
			rules: [
			],
		},
		{
			title: 'Pregnancy Warning',
			id: 'pregnancy',
			type: 'warning',
			name1: 'pregnancy',
			name2: 'pregnancyTagId',
			placeHolder: 'Select Pregnancy Warning',
			required: false,
			rules: [
			],
		},
		
		{
			title: 'Salt Composition',
			id: 'saltComposition',
			type: 'addInput',
			name: 'saltComposition',
			placeHolder: 'Enter Salt Composition',
			required: false,
			rules: [
			],
		},
		{
			title: 'Medicine Strength',
			id: 'medicineStrength',
			type: 'text',
			name: 'medicineStrength',
			placeHolder: 'Enter Medicine Strength',
			required: false,
			rules: [
				{
					pattern: /^[0-9A-Za-z/.]*$/,
					message: 'Only numbers, letters, dot (.) and forward slash (/) are allowed',
					validateTrigger: 'onChange',
				},
				{
					validator: (_: any, value: any) => {
						if (value == null || String(value).trim() === '') return Promise.resolve();
						if (!/[0-9A-Za-z]/.test(String(value))) {
							return Promise.reject(new Error('Must contain at least one letter or number'));
						}
						return Promise.resolve();
					},
					validateTrigger: 'onChange',
				},
			],
		},
		{
			title: 'MRP',
			id: 'mrp',
			type: 'number',
			name: 'mrp',
			step: 0.001,
			placeHolder: 'Enter MRP',
			required: true,
			rules: [
				{
					required: true,
					message: 'Please enter MRP',
					validateTrigger: 'onChange',
				},
				{
					pattern: /^(?!-).*$/,
					message: 'MRP cannot be negative',
					validateTrigger: 'onChange',
				},
			],
		},
		{
			title: 'GST Percentage',
			id: 'gstPercentage',
			type: 'number',
			name: 'gstPercentage',
			placeHolder: 'Enter GST Percentage',
			required: true,
			rules: [
				{
					required: true,
					message: 'Please enter GST Percentage',
					validateTrigger: 'onChange',
				},
				{
					pattern: /^(?!-).*$/,
					message: 'GST Percentage cannot be negative',
					validateTrigger: 'onChange',
				},
			],
		},
		{
			title: 'Route of Administration',
			id: 'routeOfAdministration',
			type: 'text',
			name: 'routeOfAdministration',
			placeHolder: 'Enter Route of Administration',
			required: false,
			rules: [
				{
					max: 20,
					message: 'Route of Administration must be less than 20 characters',
					validateTrigger: 'onChange',
				},
			],
		},
		{
			title: 'Country of Origin',
			id: 'countryOfOrigin',
			type: 'dropdown',
			name: 'countryOfOrigin',
			placeHolder: 'Enter Country of Origin',
			required: true,
			rules: [
				{
					required: true,
					message: 'Please Select Country of Origin',
					validateTrigger: 'onChange',
				},
			],
		},
		{
			title: 'Category',
			id: 'categoryId',
			type: 'dropdown',
			name: 'categoryId',
			placeHolder: 'Select Category',
			required: false,
			rules: [
				{
					required: true,
					message: 'Please Select Category',
					validateTrigger: 'onChange',
				},
			],
		},
		{
			title: 'Dose Form',
			id: 'doseFormId',
			type: 'dropdown',
			name: 'doseFormId',
			placeHolder: 'Select Dose Form',
			required: true,
			rules: [
				{
					required: true,
					message: 'Please Select Dose Form',
					validateTrigger: 'onChange',
				},
			],
		},
		{
			title: 'Sub Category',
			id: 'subCategoryId',
			type: 'dropdown',
			name: 'subCategoryId',
			placeHolder: 'Select Sub Category',
			required: false,
			rules: [
				{
					required: true,
					message: 'Please Select Sub Category',
					validateTrigger: 'onChange',
				},
			],
		},
		{
			title: 'Side Effects',
			id: 'sideEffects',
			type: 'text',
			name: 'sideEffects',
			placeHolder: 'Enter Side Effects',
			required: false,
			rules: [
			],
		},
		{
			title: 'NDC Code',
			id: 'ndcCode',
			type: 'text',
			name: 'ndcCode',
			placeHolder: 'Enter NDC Code',
			required: false,
			rules: [
			],
		},
		{
			title: 'Barcode',
			id: 'barcodeSKU',
			type: 'number',
			name: 'barcodeSKU',
			placeHolder: 'Enter Barcode',
			required: false,
			rules: [
			]
		},
		{
			title: 'Storage Instructions',
			id: 'storageInstructions',
			type: 'text',
			name: 'storageInstructions',
			placeHolder: 'Enter Storage Instructions',
			required: false,
			rules: [
			],
		},
		{
			title: 'How to Use',
			id: 'howToUse',
			type: 'text',
			name: 'howToUse',
			placeHolder: 'Enter How to Use',
			required: false,
			rules: [
			],
		},
		{
			title: 'Weightage',
			id: 'weightage',
			type: 'number',
			name: 'weightage',
			step: 0.001,
			placeHolder: 'Enter Weightage',
			required: true,
			rules: [
				{
					required: true,
					message: 'Please enter Weightage',
					validateTrigger: 'onChange',
				},
				{
					pattern: /^(?!-).*$/,
					message: 'Weightage cannot be negative',
					validateTrigger: 'onChange',
				},
			],
		},
		{
			title: 'Number of Items',
			id: 'numberOfItems',
			type: 'text',
			name: 'numberOfItems',
			placeHolder: 'Enter number of items',
			required: true,
			rules: [
				{
					required: true,
					message: 'Please enter number of items',
					validateTrigger: 'onChange',
				},
				{
					pattern: /^[1-9]\d*$/,
					message: 'Number of items must be a positive integer',
					validateTrigger: 'onChange',
				},
			],
		},
		{
			title: 'Flavour',
			id: 'flavour',
			type: 'text',
			name: 'flavour',
			placeHolder: 'Enter Flavour',
			required: false,
			rules: [
			],
		},
		{
			title: 'Rx Required',
			id: 'rxRequired',
			type: 'dropdown',
			name: 'rxRequired',
			placeHolder: 'Select Rx Required',
			required: true,
			roleOptions: [
				{ label: 'Yes', value: true },
				{ label: 'No', value: false },
			],
			rules: [
				{
					required: true,
					validator: (_: any, value: any) => {
						if (value === true || value === false) {
							return Promise.resolve();
						}
						return Promise.reject(new Error('Please select Rx Required'));
					},
				},
			],
		},
		{
			title: 'Schedule Type',
			id: 'scheduleType',
			type: 'dropdown',
			name: 'scheduleType',
			placeHolder: 'Select Schedule Type',
			required: true,
			roleOptions: [
				{ label: 'H', value: 'H' },
				{ label: 'H1', value: 'H1' },
				{ label: 'X', value: 'X' },
				{ label: 'K', value: 'K' },
				{ label: 'C', value: 'C' },
				{ label: 'G', value: 'G' },
				{ label: 'NRX', value: 'NRX' },
				{ label: 'TB', value: 'TB' },
				{ label: 'NON_SCHEDULE', value: 'NON_SCHEDULE' },
			],
			rules: [
				{
					required: true,
					message: 'Please enter Medicine Name',
					validateTrigger: 'onChange',
				},
			],
		},
		{
			title: 'Uses Tags',
			id: 'usesTags',
			type: 'text',
			name: 'usesTags',
			placeHolder: 'Select Uses Tags',
			required: true,
			rules: [
				{
					required: true,
					message: 'Please enter Uses Tags',
					validateTrigger: 'onChange',
				},
			],
		},
		{
			title: 'Primary Image',
			id: 'primaryImage',
			type: 'primaryImage',
			name: 'primaryImage',
			defaultValue: [''],
			placeHolder: 'Upload Images ',
		},
		{
			title: 'Secondary Image',
			id: 'secondaryImage',
			type: 'secondaryImage',
			name: 'secondaryImage',
			defaultValue: [''],
			placeHolder: 'Upload Images ',
		},
	],
	addRoleFields: [
		{
			title: 'Role Name',
			id: 'roleName',
			type: 'text',
			name: 'roleName',
			defaultValue: '',
			placeholder: 'Enter role name',
			placeHolder: '',
			required: true,
			rules: [
				{
					required: true,
					message: 'Please enter role name',
					validateTrigger: 'onChange',
				},
				{
					max: 50,
					message: 'Role name length must be less than 50 characters',
					validateTrigger: 'onChange',
				},
				{ validator: validateNoOnlySpaces },
			],
		},
		{
			title: 'Description',
			id: 'roleDescription',
			type: 'textArea',
			name: 'roleDescription',
			defaultValue: '',
			placeholder: 'Enter role description',
			placeHolder: '',
			required: true,
			rules: [
				{
					required: true,
					message: 'Please enter role description',
					validateTrigger: 'onSubmit',
				},
				{
					max: 200,
					message:
						'Role description length must be less than 200 characters',
					validateTrigger: 'onChange',
				},
				{ validator: validateNoOnlySpaces },
			],
		},
	],
	doseFields: [
		{
			title: 'Dose Form',
			id: 'name',
			type: 'text',
			name: 'name',
			defaultValue: '',
			placeholder: 'Enter dose form',
			placeHolder: '',
			required: true,
			rules: [
				{
					required: true,
					message: 'Please enter dose form',
					validateTrigger: 'onChange',
				},
				{
					max: 50,
					message: 'Dose form length must be less than 50 characters',
					validateTrigger: 'onChange',
				},
				{ validator: validateNoOnlySpaces },
			],
		},
	],
	warningTagsFields: [
		{
			title: 'Warning Tag',
			id: 'tagName',
			type: 'text',
			name: 'tagName',
			defaultValue: '',
			placeholder: 'Enter warning tag',
			placeHolder: '',
			required: true,
			rules: [
				{
					required: true,
					message: 'Please enter warning tag',
					validateTrigger: 'onChange',
				},
				{
					max: 50,
					message: 'Warning tag length must be less than 50 characters',
					validateTrigger: 'onChange',
				},
				{ validator: validateNoOnlySpaces },
			],
		},
	],
	categoryFields: [
		{
			title: 'Category Name',
			id: 'categoryName',
			type: 'text',
			name: 'categoryName',
			defaultValue: '',
			placeholder: 'Enter category name',
			placeHolder: '',
			required: true,
			rules: [
				{
					required: true,
					message: 'Please enter category name',
					validateTrigger: 'onChange',
				},
				{
					max: 50,
					message: 'Category name length must be less than 50 characters',
					validateTrigger: 'onChange',
				},
				{ validator: validateNoOnlySpaces },
			],
		},
	],
	subCategoryFields: [
		{
			title: 'Sub Category Name',
			id: 'subCategoryName',
			type: 'text',
			name: 'subCategoryName',
			defaultValue: '',
			placeholder: 'Enter sub category name',
			placeHolder: '',
			required: true,
			rules: [
				{
					required: true,
					message: 'Please enter sub category name',
					validateTrigger: 'onChange',
				},
				{
					max: 50,
					message: 'Sub Category name length must be less than 50 characters',
					validateTrigger: 'onChange',
				},
				{ validator: validateNoOnlySpaces },
			],
		},
	],
	addGroceryFields: [
		{
			title: 'Product Name',
			id: 'productName',
			type: 'text',
			name: 'productName',
			placeHolder: 'Enter product name',
			required: true,
			rules: [
				{ required: true, message: 'Please enter product name', validateTrigger: 'onChange' },
				{ max: 200, message: 'Product name must be less than 200 characters', validateTrigger: 'onChange' },
			],
		},
		{
			title: 'Brand',
			id: 'brand',
			type: 'text',
			name: 'brand',
			placeHolder: 'Enter brand',
			required: true,
			rules: [
				{ required: true, message: 'Please enter brand', validateTrigger: 'onChange' },
				{ max: 100, message: 'Brand must be less than 100 characters', validateTrigger: 'onChange' },
			],
		},
		{
			title: 'Manufacturer',
			id: 'manufacturerName',
			type: 'text',
			name: 'manufacturerName',
			placeHolder: 'Enter manufacturer',
			required: true,
			rules: [
				{ required: true, message: 'Please enter manufacturer', validateTrigger: 'onChange' },
				{ max: 100, message: 'Manufacturer must be less than 100 characters', validateTrigger: 'onChange' },
			],
		},
		{
			title: 'Marketed By',
			id: 'marketedBy',
			type: 'text',
			name: 'marketedBy',
			placeHolder: 'Enter marketed by',
			required: true,
			rules: [
				{ required: true, message: 'Please enter marketed by', validateTrigger: 'onChange' },
				{ max: 100, message: 'Marketed by must be less than 100 characters', validateTrigger: 'onChange' },
			],
		},
		{
			title: 'Category',
			id: 'categoryId',
			type: 'dropdown',
			name: 'categoryId',
			placeHolder: 'Select category',
			required: true,
			rules: [{ required: true, message: 'Please select category', validateTrigger: 'onChange' }],
		},
		{
			title: 'Sub Category',
			id: 'subCategoryId',
			type: 'dropdown',
			name: 'subCategoryId',
			placeHolder: 'Select sub category',
			required: true,
			rules: [{ required: true, message: 'Please select sub category', validateTrigger: 'onChange' }],
		},
		{
			title: 'Description',
			id: 'description',
			type: 'text',
			name: 'description',
			placeHolder: 'Enter description',
			required: false,
			rules: [{ max: 500, message: 'Description must be less than 500 characters', validateTrigger: 'onChange' }],
		},
		{
			title: 'Pack Type',
			id: 'packType',
			type: 'dropdown',
			name: 'packType',
			placeHolder: 'Select pack type',
			required: true,
			rules: [{ required: true, message: 'Please select pack type', validateTrigger: 'onChange' }],
			roleOptions: GROCERY_PACK_TYPE_OPTIONS,
		},
		{
			title: 'Weightage',
			id: 'weightage',
			type: 'number',
			name: 'weightage',
			step: 0.001,
			placeHolder: 'Enter weightage',
			required: true,
			rules: [
				{
					required: true,
					message: 'Please enter weightage',
					validateTrigger: 'onChange',
				},
				{
					pattern: /^(?!-).*$/,
					message: 'Weightage cannot be negative',
					validateTrigger: 'onChange',
				},
			],
		},
		{
			title: 'Unit of Measure',
			id: 'unitOfMeasure',
			type: 'dropdown',
			name: 'unitOfMeasure',
			placeHolder: 'Select unit',
			required: true,
			rules: [{ required: true, message: 'Please select unit of measure', validateTrigger: 'onChange' }],
			roleOptions: [
				{ value: 'gm', label: 'gm' },
				{ value: 'kg', label: 'kg' },
				{ value: 'ml', label: 'ml' },
				{ value: 'ltr', label: 'ltr' },
				{ value: 'unit', label: 'unit' },
				{ value: 'mg', label: 'mg' },
				{ value: 'pieces', label: 'pieces' },
				{ value: 'tablet', label: 'tablet' },
				{ value: 'syrup', label: 'syrup' },
				{ value: 'capsule', label: 'capsule' },
			],
		},
		{
			title: 'Number of Items',
			id: 'numberOfItems',
			type: 'text',
			name: 'numberOfItems',
			placeHolder: 'Enter number of items',
			required: false,
		},
		{
			title: 'HSN Code',
			id: 'hsnCode',
			type: 'text',
			name: 'hsnCode',
			placeHolder: 'Enter HSN code',
			required: false,
		},
		{
			title: 'Product Code',
			id: 'productCode',
			type: 'text',
			name: 'productCode',
			placeHolder: 'Enter Product Code',
			required: false,
			rules: [],
		},
		{
			title: 'Tax Rate (%)',
			id: 'taxRate',
			type: 'number',
			name: 'taxRate',
			placeHolder: 'Enter tax rate',
			required: true,
			rules: [{ required: true, message: 'Please enter tax rate', validateTrigger: 'onChange' }],
		},
		{
			title: 'MRP',
			id: 'mrp',
			type: 'number',
			name: 'mrp',
			step: 0.001,
			placeHolder: 'Enter MRP',
			required: true,
			rules: [
				{
					required: true,
					message: 'Please enter MRP',
					validateTrigger: 'onChange',
				},
				{
					pattern: /^(?!-).*$/,
					message: 'MRP cannot be negative',
					validateTrigger: 'onChange',
				},
			],
		},
		{
			title: 'Retail Price (INR)',
			id: 'retailPriceInr',
			type: 'number',
			name: 'retailPriceInr',
			placeHolder: 'Enter retail price',
			required: false,
		},
		{
			title: 'Perishable',
			id: 'isPerishable',
			type: 'dropdown',
			name: 'isPerishable',
			placeHolder: 'Select',
			required: false,
			roleOptions: [
				{ value: 'true', label: 'Yes' },
				{ value: 'false', label: 'No' },
			],
		},
		{
			title: 'Packaged',
			id: 'isPackaged',
			type: 'dropdown',
			name: 'isPackaged',
			placeHolder: 'Select',
			required: false,
			roleOptions: [
				{ value: 'true', label: 'Yes' },
				{ value: 'false', label: 'No' },
			],
		},
		{
			title: 'Halal Certified',
			id: 'isHalalCertified',
			type: 'dropdown',
			name: 'isHalalCertified',
			placeHolder: 'Select',
			required: false,
			roleOptions: [
				{ value: 'true', label: 'Yes' },
				{ value: 'false', label: 'No' },
			],
		},
		{
			title: 'FSSAI License No',
			id: 'fssaiLicenseNo',
			type: 'text',
			name: 'fssaiLicenseNo',
			placeHolder: 'Enter FSSAI license',
			required: false,
		},
		{
			title: 'Country of Origin',
			id: 'countryOfOrigin',
			type: 'dropdown',
			name: 'countryOfOrigin',
			placeHolder: 'Select country',
			required: false,
		},
		{
			title: 'Shelf Life',
			id: 'shelfLife',
			type: 'text',
			name: 'shelfLife',
			placeHolder: 'Enter shelf life',
			required: false,
		},
		{
			title: 'Ingredients',
			id: 'ingredients',
			type: 'text',
			name: 'ingredients',
			placeHolder: 'Enter ingredients',
			required: false,
		},
		{
			title: 'Allergen Info',
			id: 'allergenInfo',
			type: 'text',
			name: 'allergenInfo',
			placeHolder: 'Enter allergen info',
			required: false,
		},
		{
			title: 'Barcode',
			id: 'barcode',
			type: 'text',
			name: 'barcode',
			placeHolder: 'Enter barcode',
			required: true,
			rules: [
				{ required: true, message: 'Please enter barcode', validateTrigger: 'onChange' },
				{ validator: validateNoOnlySpaces },
			],
		},
		{
			title: 'Nutritional Info',
			id: 'nutritionalInfo',
			type: 'text',
			name: 'nutritionalInfo',
			placeHolder: 'Enter nutritional info',
			required: false,
		},
		{
			title: 'Storage Instructions',
			id: 'storageInstructions',
			type: 'text',
			name: 'storageInstructions',
			placeHolder: 'Enter storage instructions',
			required: false,
		},
		{
			title: 'Instructions',
			id: 'instructions',
			type: 'text',
			name: 'instructions',
			placeHolder: 'Enter instructions',
			required: false,
		},
		{
			title: 'Primary Image',
			id: 'productPrimaryImageUrl',
			type: 'primaryImage',
			name: 'primaryImage',
		},
		{
			title: 'Secondary Image',
			id: 'productSecondaryImageUrl',
			type: 'secondaryImage',
			name: 'secondaryImage',
		},
	],
	groceryCategoryFields: [
		{
			title: 'Category Name',
			id: 'name',
			type: 'text',
			name: 'name',
			defaultValue: '',
			placeholder: 'Enter category name',
			placeHolder: '',
			required: true,
			rules: [
				{
					required: true,
					message: 'Please enter category name',
					validateTrigger: 'onChange',
				},
				{
					max: 50,
					message: 'Category name length must be less than 50 characters',
					validateTrigger: 'onChange',
				},
				{ validator: validateNoOnlySpaces },
			],
		},
	],
	addComboFields: [
		{
			title: 'Combo Name',
			id: 'comboName',
			type: 'text',
			name: 'comboName',
			placeHolder: 'Enter combo name',
			required: true,
			rules: [
				{ required: true, message: 'Please enter combo name', validateTrigger: 'onChange' },
				{ max: 200, message: 'Combo name must be less than 200 characters', validateTrigger: 'onChange' },
			],
		},
		{
			title: 'Brand',
			id: 'brand',
			type: 'text',
			name: 'brand',
			placeHolder: 'Enter brand',
			required: true,
			rules: [
				{ required: true, message: 'Please enter brand', validateTrigger: 'onChange' },
				{ max: 100, message: 'Brand must be less than 100 characters', validateTrigger: 'onChange' },
			],
		},
		{
			title: 'Manufacturer',
			id: 'manufacturerName',
			type: 'text',
			name: 'manufacturerName',
			placeHolder: 'Enter manufacturer',
			required: true,
			rules: [
				{ required: true, message: 'Please enter manufacturer', validateTrigger: 'onChange' },
				{ max: 100, message: 'Manufacturer must be less than 100 characters', validateTrigger: 'onChange' },
			],
		},
		{
			title: 'Marketed By',
			id: 'marketedBy',
			type: 'text',
			name: 'marketedBy',
			placeHolder: 'Enter marketed by',
			required: true,
			rules: [
				{ required: true, message: 'Please enter marketed by', validateTrigger: 'onChange' },
				{ max: 100, message: 'Marketed by must be less than 100 characters', validateTrigger: 'onChange' },
			],
		},
		{
			title: 'Category',
			id: 'categoryId',
			type: 'dropdown',
			name: 'categoryId',
			placeHolder: 'Select category',
			required: true,
			rules: [{ required: true, message: 'Please select category', validateTrigger: 'onChange' }],
		},
		{
			title: 'Sub Category',
			id: 'subCategoryId',
			type: 'dropdown',
			name: 'subCategoryId',
			placeHolder: 'Select sub category',
			required: true,
			rules: [{ required: true, message: 'Please select sub category', validateTrigger: 'onChange' }],
		},
		{
			title: 'Description',
			id: 'description',
			type: 'text',
			name: 'description',
			placeHolder: 'Enter description',
			required: false,
			rules: [{ max: 500, message: 'Description must be less than 500 characters', validateTrigger: 'onChange' }],
		},
		{
			title: 'MRP',
			id: 'mrp',
			type: 'number',
			name: 'mrp',
			placeHolder: 'Enter MRP',
			required: true,
			rules: [{ required: true, message: 'Please enter MRP', validateTrigger: 'onChange' }],
		},
		{
			title: 'Tax Rate (%)',
			id: 'taxRate',
			type: 'number',
			name: 'taxRate',
			placeHolder: 'Enter tax rate',
			required: true,
			rules: [{ required: true, message: 'Please enter tax rate', validateTrigger: 'onChange' }],
		},
		{
			title: 'Barcode',
			id: 'barcode',
			type: 'text',
			name: 'barcode',
			placeHolder: 'Enter barcode',
			required: false,
		},
		{
			title: 'Primary Image',
			id: 'comboPrimaryImageUrl',
			type: 'primaryImage',
			name: 'primaryImage',
		},
		{
			title: 'Secondary Image',
			id: 'comboSecondaryImageUrl',
			type: 'secondaryImage',
			name: 'secondaryImage',
		},
	],
	grocerySubCategoryFields: [
		{
			title: 'Sub Category Name',
			id: 'name',
			type: 'text',
			name: 'name',
			defaultValue: '',
			placeholder: 'Enter sub category name',
			placeHolder: '',
			required: true,
			rules: [
				{
					required: true,
					message: 'Please enter sub category name',
					validateTrigger: 'onChange',
				},
				{
					max: 50,
					message: 'Sub Category name length must be less than 50 characters',
					validateTrigger: 'onChange',
				},
				{ validator: validateNoOnlySpaces },
			],
		},
	],
};

export const roleDataSource: any = [];
roleDataSource.push({
	name: `Admin`,
	description: `Description for role`,
	permissions: `Permission Details`,
	status: true,
	action: `some action`,
});

for (let index = 0; index < 15; index++) {
	roleDataSource.push({
		name: `Role ${index}`,
		description: `Description for role ${index}`,
		permissions: `Permission Details`,
		status: index % 2 === 0 ? true : false,
		action: `some action`,
	});
}

export const roleColumns = [
	{
		title: 'Role Name',
		dataIndex: 'name',
		key: 'name',
		sorter: (a: any, b: any) => {
			return a.name.length - b.name.length;
		},
		sortDirections: ['descend'],
	},
	{
		title: 'Description',
		dataIndex: 'description',
		key: 'description',
	},
	{
		title: 'Status',
		dataIndex: 'status',
		key: 'status',
	},
	{
		title: 'Permissions',
		dataIndex: 'permissions',
		key: 'permissions',
	},
	{
		title: 'Action',
		dataIndex: 'action',
		key: 'action',
	},
];

export const UserProfileData = [
	{
		title: 'First Name',
		id: 'firstName',
		type: 'text',
		name: 'firstName',
		defaultValue: '',
		disabled: false,
		errorMessage: 'Please enter your first name',
		required: true,
		rules: [
			{
				required: true,
				message: 'Please enter your first name',
				validateTrigger: 'onChange',
			},
			{
				min: 2,
				max: 40,
				message: 'First name must be between 2 and 40 characters',
				validateTrigger: 'onChange',
			},
		],
	},
	{
		title: 'Last Name',
		id: 'lastName',
		type: 'text',
		name: 'lastName',
		defaultValue: '',
		disabled: false,
		errorMessage: 'Please enter your last name',
		required: true,
		rules: [
			{
				required: true,
				message: 'Please enter your last name',
				validateTrigger: 'onChange',
			},
			{
				min: 2,
				max: 40,
				message: 'Last name must be between 2 and 40 characters',
				validateTrigger: 'onChange',
			},
		],
	},
	{
		title: 'Email Address',
		id: 'email',
		type: 'text',
		name: 'email',
		defaultValue: '',
		disabled: true,
		errorMessage: 'Please enter your email',
		required: false,
		rules: [],
	},
	{
		title: 'Role',
		id: 'role',
		type: 'text',
		name: 'role',
		defaultValue: '',
		disabled: true,
		errorMessage: 'Please enter your role',
		required: true,
		rules: [
			{
				required: true,
				message: 'Please enter your role',
				validateTrigger: 'onChange',
			},
			{
				min: 2,
				max: 40,
				message: 'Role must be between 2 and 40 characters',
				validateTrigger: 'onChange',
			},
		],
	},
	// {
	// 	title: 'Phone Number',
	// 	id: 'phone',
	// 	type: 'number',
	// 	name: 'phone',
	// 	required: false,
	// 	rules: [
	// 		{
	// 			validator: phoneNumberValidator,
	// 			message: 'Please enter valid phone number',
	// 			validateTrigger: 'onChange',
	// 		},
	// 	],
	// },
];

export const APIKey = [
	{
		title: 'API Key',
		id: 'apiKey',
		type: 'text',
		name: 'apiKey',
		defaultValue: '',
		disabled: false,
		errorMessage: 'Please enter API key',
		required: true,
		rules: [
			{
				required: true,
				message: 'Please enter API key',
				validateTrigger: 'onChange',
			},
			{
				min: 10,
				message: 'API key length must contain at least 10 characters',
				validateTrigger: 'onChange',
			},
			{
				max: 150,
				message: 'API key length must be less than 150 characters',
				validateTrigger: 'onChange',
			},
		],
	},
];

export const monthNames = [
	'January',
	'February',
	'March',
	'April',
	'May',
	'June',
	'July',
	'August',
	'September',
	'October',
	'November',
	'December',
];

export const months = [
	{ value: 1, label: 'January' },
	{ value: 2, label: 'February' },
	{ value: 3, label: 'March' },
	{ value: 4, label: 'April' },
	{ value: 5, label: 'May' },
	{ value: 6, label: 'June' },
	{ value: 7, label: 'July' },
	{ value: 8, label: 'August' },
	{ value: 9, label: 'September' },
	{ value: 10, label: 'October' },
	{ value: 11, label: 'November' },
	{ value: 12, label: 'December' },
];

export const booleanOptions = [
	{
		label: 'Yes',
		value: 'true',
	},
	{
		label: 'No',
		value: 'false',
	},
];

export const Earnings = [
	{
		id: Math.random(),
		isChecked: true,
		value: '180.00',
		isDefault: true,
		currency: 'K',
		label: 'Housing Allowance',
	},
	{
		id: Math.random(),
		isChecked: false,
		value: '',
		isDefault: true,
		currency: 'K',
		label: 'Transport Allowance',
	},
	{
		id: Math.random(),
		isChecked: false,
		value: '',
		isDefault: true,
		currency: 'K',
		label: 'Weekdays Overtime',
	},
	{
		id: Math.random(),
		isChecked: false,
		value: '',
		isDefault: true,
		currency: 'K',
		label: 'Leave Pay',
	},
	{
		id: Math.random(),
		isChecked: false,
		value: '',
		isDefault: true,
		currency: 'K',
		label: 'Sunday Overtime',
	},
	{
		id: Math.random(),
		isChecked: false,
		value: '',
		isDefault: true,
		currency: 'K',
		label: 'Gratuity Pay',
	},
	{
		id: Math.random(),
		isChecked: false,
		value: '',
		isDefault: true,
		currency: 'K',
		label: 'Lunch Allowance',
	},
	{
		id: Math.random(),
		isChecked: false,
		value: '',
		isDefault: true,
		currency: 'K',
		label: 'House Rent',
	},
	{
		id: Math.random(),
		isChecked: false,
		value: '',
		isDefault: true,
		currency: 'K',
		label: 'Seventh Day Overtime',
	},
	{
		id: Math.random(),
		isChecked: false,
		value: '',
		isDefault: true,
		currency: 'K',
		label: 'Shift Differential Pay',
	},
	{
		id: Math.random(),
		isChecked: false,
		value: '',
		isDefault: false,
		currency: 'K',
		label: 'MEDICAL ALLOWANCE',
	},
	{
		id: Math.random(),
		isChecked: false,
		value: '',
		isDefault: false,
		currency: 'K',
		label: 'ACTING ALLOWANCE',
	},
	{
		id: Math.random(),
		isChecked: false,
		value: '',
		isDefault: false,
		currency: 'K',
		label: 'WATER ALLOWANCE',
	},
	{
		id: Math.random(),
		isChecked: false,
		value: '',
		isDefault: false,
		currency: 'K',
		label: 'DOMESTIC SERV.ALLOW.',
	},
	{
		id: Math.random(),
		isChecked: false,
		value: '',
		isDefault: false,
		currency: 'K',
		label: 'PHONE ALLOWANCE',
	},
	{
		id: Math.random(),
		isChecked: false,
		value: '',
		isDefault: false,
		currency: 'K',
		label: 'TERMINAL BENEFITS',
	},
	{
		id: Math.random(),
		isChecked: false,
		value: '',
		isDefault: false,
		currency: 'K',
		label: 'NIGHT ALLOWANCE',
	},
	{
		id: Math.random(),
		isChecked: false,
		value: '',
		isDefault: false,
		currency: 'K',
		label: 'ELECTRICITY ALLOWANCE',
	},
	{
		id: Math.random(),
		isChecked: false,
		value: '',
		isDefault: false,
		currency: 'K',
		label: 'HOUSING ALLOW.ARREAS',
	},
	{
		id: Math.random(),
		isChecked: false,
		value: '',
		isDefault: false,
		currency: 'K',
		label: 'SERVICE BENEFIT',
	},
	{
		id: Math.random(),
		isChecked: false,
		value: '',
		isDefault: false,
		currency: 'K',
		label: 'XMAS BONUS',
	},
	{
		id: Math.random(),
		isChecked: false,
		value: '',
		isDefault: false,
		currency: 'K',
		label: 'ELECT.ALOW.ARREARS',
	},
	{
		id: Math.random(),
		isChecked: false,
		value: '',
		isDefault: false,
		currency: 'K',
		label: 'WAT.ALLOW.ARREARS',
	},
	{
		id: Math.random(),
		isChecked: false,
		value: '',
		isDefault: false,
		currency: 'K',
		label: 'RET.PACKAGE',
	},
	{
		id: Math.random(),
		isChecked: false,
		value: '',
		isDefault: false,
		currency: 'K',
		label: 'REPATRIATION',
	},
	{
		id: Math.random(),
		isChecked: false,
		value: '',
		isDefault: false,
		currency: 'K',
		label: 'INDUCEMENT ALLOWANCE',
	},
	{
		id: Math.random(),
		isChecked: false,
		value: '',
		isDefault: false,
		currency: 'K',
		label: 'FOOD ALLOW. ADJ.',
	},
	{
		id: Math.random(),
		isChecked: false,
		value: '',
		isDefault: false,
		currency: 'K',
		label: 'REFUND: STAFF DEBTOR',
	},
	{
		id: Math.random(),
		isChecked: false,
		value: '',
		isDefault: false,
		currency: 'K',
		label: 'SALARY ADJUSTMENT',
	},
	{
		id: Math.random(),
		isChecked: false,
		value: '',
		isDefault: false,
		currency: 'K',
		label: 'TRANSPORT ALL.ARREAR',
	},
	{
		id: Math.random(),
		isChecked: false,
		value: '',
		isDefault: false,
		currency: 'K',
		label: 'TERMIN.LVE PAY',
	},
	{
		id: Math.random(),
		isChecked: false,
		value: '',
		isDefault: false,
		currency: 'K',
		label: 'BASIC PAY RECOV.',
	},
	{
		id: Math.random(),
		isChecked: false,
		value: '',
		isDefault: false,
		currency: 'K',
		label: 'Christmas Bonus',
	},
	{
		id: Math.random(),
		isChecked: false,
		value: '',
		isDefault: false,
		currency: 'K',
		label: 'REFUND NAPSA',
	},
	{
		id: Math.random(),
		isChecked: false,
		value: '',
		isDefault: false,
		currency: 'K',
		label: 'BASIC PAY',
	},
	{
		id: Math.random(),
		isChecked: false,
		value: '',
		isDefault: false,
		currency: 'K',
		label: 'ABSENT PAY',
	},
	{
		id: Math.random(),
		isChecked: false,
		value: '',
		isDefault: false,
		currency: 'K',
		label: 'LEAVE COMMUTATION',
	},
	{
		id: Math.random(),
		isChecked: false,
		value: '',
		isDefault: false,
		currency: 'K',
		label: 'CHRISTMAS BONUS',
	},
	{
		id: Math.random(),
		isChecked: false,
		value: '',
		isDefault: false,
		currency: 'K',
		label: 'COY NAPSA CONTR.',
	},
	{
		id: Math.random(),
		isChecked: false,
		value: '',
		isDefault: false,
		currency: 'K',
		label: 'COY PENSION CONTR.',
	},
	{
		id: Math.random(),
		isChecked: false,
		value: '',
		isDefault: false,
		currency: 'K',
		label: 'ROUNDING ADJ.',
	},
	{
		id: Math.random(),
		isChecked: false,
		value: '',
		isDefault: false,
		currency: 'K',
		label: 'LEAVE PROVISION',
	},
	{
		id: Math.random(),
		isChecked: false,
		value: '',
		isDefault: false,
		currency: 'K',
		label: 'CHRISTMAS BONUS PROVISION',
	},
	{
		id: Math.random(),
		isChecked: false,
		value: '',
		isDefault: false,
		currency: 'K',
		label: 'Skills Development Levy',
	},
	{
		id: Math.random(),
		isChecked: false,
		value: '',
		isDefault: false,
		currency: 'K',
		label: 'Gross up Tax Refund',
	},
	{
		id: Math.random(),
		isChecked: false,
		value: '',
		isDefault: false,
		currency: 'K',
		label: 'NHIMA EMPLOYER CONTRIBUTION',
	},
	{
		id: Math.random(),
		isChecked: false,
		value: '',
		isDefault: false,
		currency: 'K',
		label: 'LASF EMPLOYER CONTRIBUTION',
	},
	{
		id: Math.random(),
		isChecked: false,
		value: '',
		isDefault: false,
		currency: 'K',
		label: 'MADSON FUNERAL POLICY EMPLOYER',
	},
];

export const Deductions = [
	{
		id: Math.random(),
		isChecked: false,
		value: '',
		isDefault: false,
		currency: 'K',
		label: 'PAYE',
	},
	{
		id: Math.random(),
		isChecked: true,
		value: 0,
		isDefault: false,
		currency: 'K',
		label: 'NHIMA',
	},
	{
		id: Math.random(),
		isChecked: false,
		value: 0,
		isDefault: false,
		currency: 'K',
		label: 'Mid Month',
	},
	{
		id: Math.random(),
		isChecked: false,
		value: 0,
		isDefault: false,
		currency: 'K',
		label: 'Meals/Sundry Deduction',
	},
	{
		id: Math.random(),
		isChecked: false,
		value: 0,
		isDefault: false,
		currency: 'K',
		label: 'NAPSA',
	},
	{
		id: Math.random(),
		isChecked: false,
		value: 0,
		isDefault: false,
		currency: 'K',
		label: 'House Loan',
	},
	{
		id: Math.random(),
		isChecked: false,
		value: 0,
		isDefault: false,
		currency: 'K',
		label: 'Medical Fund',
	},
	{
		id: Math.random(),
		isChecked: true,
		value: 0,
		isDefault: false,
		currency: 'K',
		label: 'Union Contribution',
	},
];

export const EmployeeData = [
	{
		id: Math.random(),
		label: 'First Name',
		fieldName: 'firstName',
		sendApproval: false,
		sectionName: 'Personal Details',
		moduleName: 'EMPLOYEE',
	},
	{
		id: Math.random(),
		label: 'Last Name',
		fieldName: 'lastName',
		sendApproval: false,
		sectionName: 'Personal Details',
		moduleName: 'EMPLOYEE',
	},
	{
		id: Math.random(),
		label: 'DOB',
		fieldName: 'dateOfBirth',
		sendApproval: false,
		sectionName: 'Personal Details',
		moduleName: 'EMPLOYEE',
	},
	{
		id: Math.random(),
		label: 'Gender',
		fieldName: 'gender',
		sendApproval: false,
		sectionName: 'Personal Details',
		moduleName: 'EMPLOYEE',
	},
	{
		id: Math.random(),
		label: 'Country',
		fieldName: 'country',
		sendApproval: false,
		sectionName: 'Personal Details',
		moduleName: 'EMPLOYEE',
	},
	{
		id: Math.random(),
		label: 'Marital Status',
		fieldName: 'maritalStatus',
		sendApproval: false,
		sectionName: 'Personal Details',
		moduleName: 'EMPLOYEE',
	},
	{
		id: Math.random(),
		label: 'SSN',
		fieldName: 'ssn',
		sendApproval: false,
		sectionName: 'Identification Details',
		moduleName: 'EMPLOYEE',
	},
	{
		id: Math.random(),
		label: 'Passport No.',
		fieldName: 'passportNo',
		sendApproval: false,
		sectionName: 'Identification Details',
		moduleName: 'EMPLOYEE',
	},
	{
		id: Math.random(),
		label: 'National Registration No.',
		fieldName: 'nationalRegistrationNo',
		sendApproval: false,
		sectionName: 'Identification Details',
		moduleName: 'EMPLOYEE',
	},
	{
		id: Math.random(),
		label: 'Record Status',
		fieldName: 'recordStatus',
		sendApproval: false,
		sectionName: 'Identification Details',
		moduleName: 'EMPLOYEE',
	},
	{
		id: Math.random(),
		label: 'Joining Date',
		fieldName: 'joiningDate',
		sendApproval: false,
		sectionName: 'Employee Details',
		moduleName: 'EMPLOYEE',
	},
	{
		id: Math.random(),
		label: 'Branch',
		fieldName: 'branch',
		sendApproval: false,
		sectionName: 'Employee Details',
		moduleName: 'EMPLOYEE',
	},
	{
		id: Math.random(),
		label: 'Department',
		fieldName: 'department',
		sendApproval: false,
		sectionName: 'Employee Details',
		moduleName: 'EMPLOYEE',
	},
	{
		id: Math.random(),
		label: 'Department',
		fieldName: 'department',
		sendApproval: false,
		sectionName: 'Employee Details',
		moduleName: 'EMPLOYEE',
	},
	{
		id: Math.random(),
		label: 'Cost Center',
		fieldName: 'costCenter',
		sendApproval: false,
		sectionName: 'Employee Details',
		moduleName: 'EMPLOYEE',
	},
	{
		id: Math.random(),
		label: 'Category',
		fieldName: 'category',
		sendApproval: false,
		sectionName: 'Employee Details',
		moduleName: 'EMPLOYEE',
	},
	{
		id: Math.random(),
		label: 'Job Grade',
		fieldName: 'jobGrade',
		sendApproval: false,
		sectionName: 'Employee Details',
		moduleName: 'EMPLOYEE',
	},
	{
		id: Math.random(),
		label: 'Staff Code',
		fieldName: 'staffCode',
		sendApproval: false,
		sectionName: 'Employee Details',
		moduleName: 'EMPLOYEE',
	},
];

export const TaxationData = [
	{
		id: Math.random(),
		label: 'Employee TPIN',
		isChecked: false,
	},
	{
		id: Math.random(),
		label: 'Taxation Method',
		isChecked: false,
	},
	{ id: Math.random(), label: 'Salary', isChecked: false },
	{
		id: Math.random(),
		label: 'Enable Gross up tax?',
		isChecked: false,
	},
	{
		id: Math.random(),
		label: 'Gross up all earnings',
		isChecked: false,
	},
	{ id: Math.random(), label: 'Currency', isChecked: false },
	{
		id: Math.random(),
		label: 'Employment Type',
		isChecked: false,
	},
	{
		id: Math.random(),
		label: 'NAPSA Paid By',
		isChecked: false,
	},
	{
		id: Math.random(),
		label: 'Employee with Disabilities',
		isChecked: false,
	},
	{
		id: Math.random(),
		label: 'Termination Date',
		isChecked: false,
	},
];

export const configurationModules = [
	'Branch Code',
	'Departments',
	'Job Grade',
	'Payment Type',
	'Payment Method',
	'Pay Point',
	'Earning',
	'Deduction',
	'Cost Center',
	'Category',
	'Job Title',
	'Leave Management',
	'Holidays',
];

export const payrollModules = [
	'Company Setup',
	'Pay Period',
	'Statutory Components',
	'Pay Schedule',
	'Payroll History',
	'Mid-Month Pay',
	'Earning Code',
	'Deduction Code',
];

export const deductionFormula = {
	D1: 'First K 4, 000.00 @ 0% - 0, Next K 800.00 @ 25% - 200.00, Next K 2, 100.00 @ 30% - 630.00, Balance K 8, 100.00 @ 37.5% - 3,037.50',
	D2: '10% of total earnings (5% employee share/5% employer share)',
	D3: '2% of Basic pay (1% employee share / 1% employer share)',
	D4: 'K 200 fix as of now',
	D5: 'deduct in March and June - 7.5K in both the months',
	D6: '0.5% of total Gross emoluments',
};
export const earningsFormulaMapping = {
	Salrate: 'SAL',
	OThrs: 'OTH',
	BasicPay: 'BSP',
	leavedays: 'LVD',
	Shiftdiffhrs: 'SDH',
	noofmonthsworked: 'NMW',
};

export const deductionFormulaOptions = [
	{
		value: 'D1',
		label: 'D1',
	},
	{
		value: 'D2',
		label: 'D2',
	},
	{
		value: 'D3',
		label: 'D3',
	},
	{
		value: 'D4',
		label: 'D4',
	},
	{
		value: 'D5',
		label: 'D5',
	},
	{
		value: 'D6',
		label: 'D6',
	},
];

export const displayFormatdropdownOptions = [
	{ label: '1,234,4567', value: 1 },
	{ label: '12,34,567', value: 2 },
];

export const currencyPositionDropdownOptions = [
	{ label: 'Before', value: 'BEFORE' },
	{ label: 'After', value: 'AFTER' },
];

export const decimalPlacesdropdownOptions = [
	{ label: '0', value: 0 },
	{ label: '1', value: 1 },
	{ label: '2', value: 2 },
	{ label: '3', value: 3 },
	{ label: '4', value: 4 },
];

export const thousandSeparatordropdownOptions = [
	{ label: '(.)Dot', value: 'DOT' },
	{ label: '(,)Coma', value: 'COMA' },
];

export const negativeNumberdropdownOptions = [
	{ label: 'with negative sign(eg:- -123)', value: 'MINUS' },
	{ label: 'within parenthesis(eg:- (123))', value: 'BRACKETS' },
];

export const dateFormats = [
	{ label: 'MM/DD/YYYY', value: 'MM/DD/YYYY' },
	{ label: 'DD/MM/YYYY', value: 'DD/MM/YYYY' },
	{ label: 'YYYY/MM/DD', value: 'YYYY/MM/DD' },
];

export const monthsForCompanySetup = [
	{ label: 'January', value: 1 },
	{ label: 'February', value: 2 },
	{ label: 'March', value: 3 },
	{ label: 'April', value: 4 },
	{ label: 'May', value: 5 },
	{ label: 'June', value: 6 },
	{ label: 'July', value: 7 },
	{ label: 'August', value: 8 },
	{ label: 'September', value: 9 },
	{ label: 'October', value: 10 },
	{ label: 'November', value: 11 },
	{ label: 'December', value: 12 },
];

export const permissionObject = [
	{
		items: [1, 2, 3, 4],
	},
	{
		name: 'Time Activities',
		items: [5, 6],
	},
	{
		name: 'Settings',
		items: [7, 8, 9, 10, 11, 12, 16],
	},
	{
		name: 'Reports',
		items: [13, 14, 15],
	},
];

const formatSaltComposition = (saltComposition: any[] | null) => {
	if (!saltComposition || !Array.isArray(saltComposition) || saltComposition.length === 0) {
		return '-';
	}

	return saltComposition.map(salt => `${salt.name} (${salt.strength})`).join(', ');
};

const formatUsesTags = (usesTags: string[]) => {
	if (!usesTags || !Array.isArray(usesTags) || usesTags.length === 0) {
		return '-';
	}
	return usesTags.join(', ');
};

export const getViewComboFields = (
	combo: any,
	categoryName?: string | null,
	subCategoryName?: string | null,
) => [
	{ label: 'Combo Name', value: combo?.comboName },
	{ label: 'Brand', value: combo?.brand },
	{ label: 'Manufacturer', value: combo?.manufacturerName },
	{ label: 'Marketed By', value: combo?.marketedBy },
	{ label: 'Category', value: categoryName ?? combo?.categoryName },
	{ label: 'Sub Category', value: subCategoryName },
	{ label: 'Description', value: combo?.description },
	{ label: 'MRP', value: combo?.mrp },
	{ label: 'Tax Rate', value: combo?.taxRate },
	{ label: 'Barcode', value: combo?.barcode },
	{ label: 'Quality Check', value: combo?.qualityCheck },
];

export const getViewGroceryFields = (
	grocery: any,
	categoryName?: string | null,
	subCategoryName?: string | null,
) => [
	{ label: 'Product Name', value: grocery?.productName },
	{ label: 'Brand', value: grocery?.brand },
	{ label: 'Manufacturer', value: grocery?.manufacturerName },
	{ label: 'Marketed By', value: grocery?.marketedBy },
	{ label: 'Category', value: categoryName ?? grocery?.categoryName },
	{ label: 'Sub Category', value: subCategoryName },
	{ label: 'Description', value: grocery?.description },
	{ label: 'Pack Type', value: grocery?.packType },
	{ label: 'Weightage', value: grocery?.weightage },
	{ label: 'Unit of Measure', value: grocery?.unitOfMeasure },
	{ label: 'Number of Items', value: grocery?.numberOfItems },
	{ label: 'HSN Code', value: grocery?.hsnCode },
	{ label: 'Product Code', value: grocery?.productCode },
	{ label: 'Tax Rate', value: grocery?.taxRate },
	{ label: 'MRP', value: grocery?.mrp },
	{ label: 'Retail Price (INR)', value: grocery?.retailPriceInr },
	{ label: 'Perishable', value: grocery?.isPerishable ? 'Yes' : 'No' },
	{ label: 'Packaged', value: grocery?.isPackaged ? 'Yes' : 'No' },
	{ label: 'Halal Certified', value: grocery?.isHalalCertified ? 'Yes' : 'No' },
	{ label: 'FSSAI License No', value: grocery?.fssaiLicenseNo },
	{ label: 'Country of Origin', value: grocery?.countryOfOrigin },
	{ label: 'Shelf Life', value: grocery?.shelfLife },
	{ label: 'Ingredients', value: grocery?.ingredients },
	{ label: 'Allergen Info', value: grocery?.allergenInfo },
	{ label: 'Barcode', value: grocery?.barcode },
	{ label: 'Nutritional Info', value: grocery?.nutritionalInfo },
	{ label: 'Storage Instructions', value: grocery?.storageInstructions },
	{ label: 'Instructions', value: grocery?.instructions },
	{ label: 'Quality Check', value: grocery?.qualityCheck },
];

export const getViewMedicineFields = (medicine: any, category: any, subCategory: any, doseForm?: any, warningTags?: any) => [
	{ label: 'Medicine Name', value: medicine?.medicineName },
	{ label: 'Generic Name', value: medicine?.genericName },
	{ label: 'Brand Name', value: medicine?.brandName },
	{ label: 'Medicine Strength', value: medicine?.medicineStrength },
	{ label: 'Manufacturer', value: medicine?.manufacturer },
	{ label: 'Marketed By', value: medicine?.marketedBy },
	{ label: 'Pack Size', value: medicine?.packSize },
	{ label: 'Item Size', value: formatItemSizeLabel(medicine?.itemSize) },
	{ label: 'Number of Items', value: medicine?.numberOfItems },
	{ label: 'Unit of Measure', value: medicine?.unitOfMeasure },
	{ label: 'Salt Composition', value: formatSaltComposition(medicine?.saltComposition) },
	{ label: 'Hsn Code', value: medicine?.hsnCode },
	{ label: 'Product Code', value: medicine?.productCode },
	{ label: 'Ndc Code', value: medicine?.ndcCode },
	{ label: 'Description', value: medicine?.shortDescription },
	{ label: 'MRP', value: medicine?.mrp },
	{ label: 'GST Percentage', value: medicine?.gstPercentage },
	{ label: 'Dose Form', value: doseForm?.name },
	{	label: 'Category', value: category?.categoryName },
	{ label: 'Sub Category', value: subCategory },
	{ label: 'How to Use', value: medicine?.howToUse },
	{ label: 'Storage Instructions', value: medicine?.storageInstructions },
	{ label: 'Schedule Type', value: medicine?.scheduleType },
	{ label: 'Alcohol', value: medicine?.Warnings?.alcohol || undefined },
	{ label: 'Alcohol Tag', value: warningTags?.alcohol?.tagName || undefined },
	{ label: 'Pregnancy', value: medicine?.Warnings?.pregnancy || undefined },
	{ label: 'Pregnancy Tag', value: warningTags?.pregnancy?.tagName || undefined },
	{ label: 'Driving', value: medicine?.Warnings?.driving || undefined },
	{ label: 'Driving Tag', value: warningTags?.driving?.tagName || undefined },
	{ label: 'Liver', value: medicine?.Warnings?.liver || undefined },
	{ label: 'Liver Tag', value: warningTags?.liver?.tagName || undefined },
	{ label: 'Lactation', value: medicine?.Warnings?.lactation || undefined },
	{ label: 'Lactation Tag', value: warningTags?.lactation?.tagName || undefined },
	{ label: 'Kidney', value: medicine?.Warnings?.kidney || undefined },
	{ label: 'Kidney Tag', value: warningTags?.kidney?.tagName || undefined },
	{ label: 'Side Effects', value: medicine?.sideEffects },
	{ label: 'Barcode', value: medicine?.barcodeSKU },
	{ label: 'Weightage', value: medicine?.weightage },
	{ label: 'Flavour', value: medicine?.flavour },
	{ label: 'Uses Tags', value: formatUsesTags(medicine?.usesTags) },
	{ label: 'Route of Administration', value: medicine?.routeOfAdministration },
	{ label: 'Country of Origin', value: medicine?.countryOfOrigin },
	{ label: 'rxRequired', value: medicine?.rxRequired ? "Yes" : "No" },
];

export const LogoutIcon = () => (
	<svg width="25" height="25" viewBox="0 0 25 25" fill="none" xmlns="http://www.w3.org/2000/svg">
		<path d="M12.5 25C5.60577 25 0 19.3942 0 12.5C0 5.60577 5.60577 0 12.5 0C15.5769 0 18.5385 1.13462 20.8365 3.18269C21.2308 3.53846 21.2692 4.14423 20.9135 4.53846C20.5577 4.93269 19.9519 4.97115 19.5577 4.61538C17.6154 2.875 15.1154 1.92308 12.5096 1.92308C6.67308 1.92308 1.93269 6.66346 1.93269 12.5C1.93269 18.3365 6.67308 23.0769 12.5096 23.0769C15.1154 23.0769 17.625 22.125 19.5577 20.3846C19.9519 20.0288 20.5577 20.0673 20.9135 20.4615C21.2692 20.8558 21.2308 21.4615 20.8365 21.8173C18.5481 23.8654 15.5865 25 12.5 25ZM25 12.5C25 11.9712 24.5673 11.5385 24.0385 11.5385H8.65385C8.125 11.5385 7.69231 11.9712 7.69231 12.5C7.69231 13.0288 8.125 13.4615 8.65385 13.4615H24.0385C24.5673 13.4615 25 13.0288 25 12.5ZM9.01923 13.3846C9.14423 13.3365 9.25 13.2692 9.33654 13.1827C9.50961 13 9.61538 12.75 9.61538 12.5C9.61538 12.25 9.50961 12 9.33654 11.8173C9.24038 11.7308 9.14423 11.6635 9.01923 11.6154C8.67308 11.4615 8.24038 11.5481 7.97115 11.8173C7.79808 12 7.69231 12.25 7.69231 12.5C7.69231 12.75 7.79808 13 7.97115 13.1827C8.15385 13.3558 8.40385 13.4615 8.65385 13.4615C8.77885 13.4615 8.90385 13.4327 9.01923 13.3846ZM20.6346 17.2596L24.7115 13.1827C25.0865 12.8077 25.0865 12.2019 24.7115 11.8269L20.6346 7.75C20.2596 7.375 19.6538 7.375 19.2788 7.75C18.9038 8.125 18.9038 8.73077 19.2788 9.10577L22.6827 12.5096L19.2788 15.9135C18.9038 16.2885 18.9038 16.8942 19.2788 17.2692C19.4712 17.4615 19.7115 17.5481 19.9615 17.5481C20.2115 17.5481 20.4519 17.4519 20.6442 17.2692L20.6346 17.2596Z" fill="#FF7272" />
	</svg>

)


export const sanitizeString = (str: string) => str.replace(/<\/?[^>]+(>|$)/g, '');


export const categoriesColumns = [
	{
		title: 'Category',
		dataIndex: 'category',
		key: 'category',
	},
	{
		title: 'Entries',
		dataIndex: 'entries',
		key: 'entries',
	},

]

export const usersColumns = [
	{
		title: 'User Name',
		dataIndex: 'fullName',
		key: 'fullName',
	},
	{
		title: 'Entries',
		dataIndex: 'entries',
		key: 'entries',
	},
	{
		title: 'Approved',
		dataIndex: 'approved',
		key: 'approved',
	},
]

export const usersColumnsForQC = [
	{
		title: 'User Name',
		dataIndex: 'fullName',
		key: 'fullName',
	},
	{
		title: 'Qc Counts',
		dataIndex: 'qcCount',
		key: 'qcCount',
	},
]

export const imageManagementColumns = [
	{
		title: 'User Name',
		dataIndex: 'fullName',
		key: 'fullName',
	},
	{
		title: 'Images Uploaded',
		dataIndex: 'imageCount',
		key: 'imageCount',
	},
]

export const mappedItemsColumns = [
	{
		title: 'User Name',
		dataIndex: 'fullName',
		key: 'fullName',
	},
	{
		title: 'Mapped Items',
		dataIndex: 'mappedCount',
		key: 'mappedCount',
	},
]